import React, { useEffect, useState } from "react";
import { Button, Collapse, IconButton, TableCell, TableRow, Checkbox } from "@material-ui/core";
import { KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";
import './CustomTableRow.scss';

export function CustomTableRow(props: any) {
  const [open, setOpen] = useState(false);
  const keys = Object.keys(props.row);

  useEffect(() => {setOpen(false)}, [props.showAccordion])

  const CheckboxComponent = (checkboxProps: any) => (
    <TableCell padding="checkbox">
      <Checkbox
        onChange={(event) => props.onSelectRow(event, checkboxProps.id)}
        checked={props.rowSelected}
        inputProps={{ 'aria-labelledby': 'table-checkbox' }}
      />
    </TableCell>
  );

  const CtaComponent = (ctaProps: any) => (
    <TableCell>
      <Button
        id="custom-table-action"
        type="button"
        onClick={() => {
          props.ctaOnClick(ctaProps.valueToRemove);
          return false;
        }}
      >
        {props.ctaLabel}
      </Button>
    </TableCell>
  );

  const getRows = () => (
    <>
      {props.isCheckable ? <CheckboxComponent id={props.row.merchantId} /> : null}
      {props.isCollapsable ? (
        keys.slice(0, -1).map((key, index, keys) => (
          index < keys.length - 1 ? (
            <TableCell>{props.row[key]}</TableCell>
          ) : (
            <>
              <TableCell className="">
                {props.row[key]}
              </TableCell>
              <TableCell className="custom-table-last-column">
                <IconButton size="small" onClick={() => setOpen(!open)}>
                  {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
              </TableCell>
            </>
          )
        ))
      ) : (
        keys.map((key) => (
          <TableCell>{props.row[key]}</TableCell>
        ))
      )}
      {props.isCallToAction ? <CtaComponent valueToRemove={props.row} /> : null}
    </>
  );

  return (
    <React.Fragment>
      <TableRow>
        {getRows()}
      </TableRow>
      {props.isCollapsable ? (
        <>
          <TableRow className="custom-table-row-underline">
            <TableCell className={`custom-table-collapsable-cell ${open ? 'open' : ''}`} colSpan={6}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <div>
                  <h4 className="custom-table-tid-list-label">{props.collapseLabel}</h4>
                  <p className="custom-table-tid-list">{props.row.terminalInfo.map((term: any) => term.termId).join(" - ")}</p>
                </div>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      ) : null}
    </React.Fragment>
  );
}
